'use strict';

function LogIn() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_Secured, _AnalyticsData, _Paths, PartnerAttribution, SessionUtm]; // _Secured Just for paths
  this.priority = 1001;
  this._submitButton = null;
  this._session = new Session();
  this._analytics = new Analytics();

  this.returnUrl = null;

  this.init = function () {
    // location.referred
    this._form = this.node.querySelector('.js--login-form');
    this.username = $('.username--textField', this.node);
    this.password = $('.password--textField', this.node);

    // Event Listners
    this.username.on('blur', this.trimUsername.bind(this));

    if (location.pathname == '/login' && this._session.getAuthToken() != '') {
      window.location.replace(this._DEFAULT_LOGGEDIN_PATH);
    }

    this._analytics.update(this.analyticsData, this);

    var schemaReq = new APIRequest('/schemas?filter=login', 'GET', null, $.proxy(this._onGetSchema, this), null, true);
    schemaReq.send();

    this.setPartnerAttribution();
    this.setSessionUtm();

    this.returnUrl = Cookies.get('returnurl');
    if (this.returnUrl) {
      // clear the return url
      Cookies.remove('returnurl', { path: '/' });
    }

    this._disableSubmitOnEnter();
    this._purgeLiveChatSession(window.location.pathname + window.location.search);

    var browserLang = navigator.language || navigator.userLanguage;
    this._browserlanguage = browserLang.toLowerCase();
    if (this._browserlanguage === 'fr' || this._browserlanguage === 'fr-fr' || this._browserlanguage === 'fr-ca') {
      this._showFrenchLanguage = true;
    }

    if (window.location.pathname === '/login') {
      this.frBrowserLanguageRedirect();
    }
  };

  this.initAllReady = function () {
    this._displayNotifications();
    this._submitButton = $('.button', this.node).show();
    $(this.node).off('keyup.blocksubmit keypress.blocksubmit keydown.blocksubmit');
  };

  this.frBrowserLanguageRedirect = function () {
    // Getting browser language and do the redirect if needed
    if (this._showFrenchLanguage) {
      window.location.replace('/fr' + window.location.pathname + window.location.search);
    }
    return false;
  };

  this.trimUsername = function (e) {
    var str = $(e.target).val();
    var trimmedStr = str.trim();
    return $(e.target).val(trimmedStr);
  };

  this._purgeLiveChatSession = function (location) {
    // Only purge the chat session if the user has logged out or the session
    // has expired
    if (location == this._LOGOUT_PATH || location == this._SESSION_EXPIRE_PATH) {
      window.__lc = { license: window.location.host === 'www.mogo.ca' ? 8375971 : 8555198 };
      window.LC_API = window.LC_API || {};
      window.LC_API.on_before_load = function () {
        window.LC_API.hide_chat_window();
      };
      window.LC_API.on_after_load = function () {
        if (window.LC_API.get_visitor_id() !== null || window.LC_API.visitor_queued()) window.LC_API.close_chat();
      };
      $('body').append('<script src="https://cdn.livechatinc.com/tracking.js" type="text/javascript" async="true"></script>');
    }
  };

  this._displayNotifications = function () {
    var notification = getURLParameter('notification').trim();

    var content = {
      msgTimeOut: {
        en: "Time out! Your account's been idle for more than 15 minutes.",
        fr: 'Session expirée ! Votre compte est inactif depuis plus de 15 minutes.'
      },
      msgLogOut: {
        en: "You're now logged out!",
        fr: 'Vous êtes déconnecté(e)!'
      },
      msgWarning: {
        en: "Woah, that link's expired like last week's milk.",
        fr: 'Ouf, ce lien est expiré depuis un bon bout de temps!'
      }
    };

    if (notification) {
      switch (notification) {
        case 'expired-session':
          $('#Notification').mogo().create({
            type: 'timeout',
            msg: this._showFrenchLanguage ? content.msgTimeOut.fr : content.msgTimeOut.en,
            isPersistent: true
          });
          this._analytics.pushEvent(notification);
          break;
        case 'logged-out':
          $('#Notification').mogo().create({
            type: 'success',
            msg: this._showFrenchLanguage ? content.msgLogOut.fr : content.msgLogOut.en
          });
          this._analytics.pushEvent(notification);
          break;
        case 'already-verified':
          $('#Notification').mogo().create({
            type: 'warning',
            msg: this._showFrenchLanguage ? content.msgWarning.fr : content.msgWarning.en
          });
          break;
      }
    }
  };

  this._onGetSchema = function (data, response, status) {
    if (response == 200) {
      var schema = JSON.parse(data[0].schema);

      // remove FE validation requirement, promo code has already been validated
      delete schema.properties.promo_code;

      $('form', this.node).mogo().create('SchemaValidation', {
        schema: schema,
        onSubmit: this._onValidate.bind(this)
      });
    } else {
      this._setButtonLoadState(false);
    }
  };

  this._onValidate = function (resultObj) {
    if (resultObj.count == 0) {
      this._setButtonLoadState(true);
      var formAnalyticsID = $('form', this.node).data('analytics-id');
      var data = $('form', this.node).serializeFormToObj();
      delete data.device_token;
      delete data.device_id;
      delete data.device_name;

      // add promo code to payload if exists
      this.promoCode = new PromoCode();
      this.promoData = this.promoCode.get();
      if (this.promoData) {
        data.promo_code = this.promoData.promo_code;
      }

      this._session.createSession(data, $.proxy(this._onLogIn, this));
    }
    return false;
  };

  this._setButtonLoadState = function (disabled) {
    if (disabled) {
      this._submitButton.mogo().setDisabledLoadState();
    } else {
      this._submitButton.mogo().removeDisabledLoadState();
    }
  };

  this._disableSubmitOnEnter = function () {
    // don't let users submit the form using the enter key until we ready.
    $(this.node).on('keyup.blocksubmit keypress.blocksubmit keydown.blocksubmit', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });
  };

  this._onLogIn = function (success, data) {
    if (success) {
      var _window = window,
          sessionStorage = _window.sessionStorage;

      var formAnalyticsID = $('form', this.node).data('analytics-id');
      this._analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });

      // note: after a member successfully logs in, we read this session value from inside UI_core.
      try {
        sessionStorage.setItem('startSessionLogin', true);
      } catch (e) {
        // note: intentionally blank. empty catch will prevent console exception.
      }

      if (this.promoData) {
        this.promoCode.delete();
      }
      if (this.returnUrl) {
        location.replace(this.returnUrl);
      } else if (document.referrer && document.referrer.indexOf(location.origin) === 0 && document.referrer != location.href && document.referrer.indexOf('/member') != -1) {
        location.replace(document.referrer);
      } else {
        location.replace(this._DEFAULT_LOGGEDIN_PATH);
      }
    } else {
      var content = {
        msgWarning1: {
          en: 'This account has been deactivated. Please contact our support team for help.',
          fr: 'Ce compte a été désactivé. Veuillez contacter notre équipe de soutien.'
        },
        msgWarning2: {
          en: "Woah there, that doesn't look like the right email address/password.",
          fr: "Oups… l'adresse courriel et le mot de passe ne semblent pas correspondre."
        }
      };
      if (data && data.errors[0].code == 400 && data.errors[0].key == 'member_service_service_errors_account_deactivated') {
        $('#Notification').mogo().create({
          type: 'warning',
          msg: this._showFrenchLanguage ? content.msgWarning1.fr : content.msgWarning1.en
        });
        this._analytics.forcePushEvent('form-errors', { FormErrors: ['De-activated'] });
      } else if (data && data.errors[0].code == 401 && data.errors[0].key == 'incorrect_email_address_or_password') {
        $('#Notification').mogo().create({
          type: 'warning',
          msg: this._showFrenchLanguage ? content.msgWarning2.fr : content.msgWarning2.en
        });
        this._analytics.forcePushEvent('form-errors', { FormErrors: ['Unauthorized'] });
      } else if (data && data.errors[0].code == 503) {
        // Account services offline - forward to maintenance page
        location.replace(this.paths.maintenance);
      } else {
        $('#Notification').mogo().get();
      }
      this._setButtonLoadState(false);
    }
  };
}